import '.k{display:grid;}.ssr-plugin'
import '.l{grid-template-columns:minmax(0, 1fr);}.ssr-plugin'
import '.f{gap:1.5rem;}.ssr-plugin'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { useEffect, useState } from 'react'
import { useClient, useLoading } from '@based/sdk/react'
import { ElearningItem } from '@schema/elearningItem'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { styled } from 'inlines'
import { useTranslations } from '@i18n/useLanguage'
import { useInfiniteScroll } from '@app/util/useInfiniteScroll'
import { PageLayout } from '../layout/PageLayout'
import { Title } from '@app/components/core/typography/Title'

export const Elearning = () => {
  const t = useTranslations().app.elearningPage
  return (
    <PageLayout>
      <Title.H1 style={{ textAlign: 'center' }}>{t.title}</Title.H1>
      <ElearningItemsList />
    </PageLayout>
  )
}

const PAGE_SIZE = 9

export const ElearningItemsList = () => {
  const t = useTranslations().app.elearningPage
  const [elearningItems, setElearningItems] = useState<ElearningItem[]>([])
  const [total, setTotal] = useState(0)
  const [top, setTop] = useState(PAGE_SIZE)
  const client = useClient()
  const isLoading = useLoading()
  const [, setLocation] = useLocation()

  useEffect(() => {
    const cleanupCount = client
      .query('list-elearning-item', { count: true })
      .subscribe((r) => setTotal(r.count))
    const cleanupQuery = client
      .query('list-elearning-item', { top })
      .subscribe((data) => setElearningItems(data))
    return () => {
      cleanupCount()
      cleanupQuery()
    }
  }, [client, top])

  const { lastItemRef } = useInfiniteScroll({
    isLoading,
    hasMore: elearningItems.length < total,
    loadMore: () => setTop((prev) => prev + PAGE_SIZE),
  })

  if (isLoading) {
    return <div>{t.loading}</div>
  }

  return (
    <styled.div className="k l f"
      style={{
        '@media (min-width: 800px)': {
          gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
          '& > :nth-child(1)': {
            gridColumn: 'span 2',
          },
        },
      }}
    >
      {elearningItems.map((item: ElearningItem, index: number) => {
        const card = (
          <BlogCard
            title={item.title}
            meta={new Date(item.publishedAt).toLocaleDateString()}
            image={item.images?.[0]?.src}
            onClick={() => setLocation(pages.elearningItem(item.slug))}
          />
        )
        if (index === elearningItems.length - 1) {
          return (
            <span key={item.id} ref={lastItemRef}>
              {card}
            </span>
          )
        }
        return <span key={item.id}>{card}</span>
      })}
    </styled.div>
  )
}
